export const formatLocaleNumber = (value: `${number}` | '', locale: string = 'ko-KR') => {
  if (value === '') return '';

  const number = Number(value);
  return number.toLocaleString(locale);
};
